<template>
  <div class="pagination">
    <div class="item mr-2" :class="{'active': value === 0}" @click="$emit('input',0)" />
    <div class="item mr-2" :class="{'active': value === 1}" @click="$emit('input',1)" />
    <div class="item mr-2" :class="{'active': value === 2}" @click="$emit('input',2)" />
  </div>
</template>

<script>
export default {
  name: 'SlidePagination',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  .item {
    cursor: pointer;
    display: inline-block;
    width: 50px;
    height: 4px;
    background: #FFFFFF;
    opacity: 0.2;
    border-radius: 10px;
    &.active {
      background: #FFFFFF;
      opacity: 1;
    }
  }
</style>
